// ===============================
// FITRACK - GYM DATA
// Change your gym information here
// ===============================

export const CONTACT_INFO = {
  location: "Mohali, Punjab",

  whatsapp: "917719433258",

  phone1: "+91 7719433258",
  phone2: "+91 6283578857",

  email: "gym@gmail.com",

  map: "https://www.google.com/maps/search/?api=1&query=Mohali+Punjab",
};

// ===============================
// MEMBERSHIP PLANS
// ===============================

export const PLANS = [
  {
    name: "Monthly",
    price: 999,
    duration: "1 Month",
  },
  {
    name: "Quarterly",
    price: 2499,
    duration: "3 Months",
  },
  {
    name: "Half Yearly",
    price: 4499,
    duration: "6 Months",
  },
  {
    name: "Yearly",
    price: 7999,
    duration: "12 Months",
  },
];

// ===============================
// GYM AREAS
// ===============================

export const GYM_AREAS = [
  {
    title: "Strength Zone",
    description: "Modern machines and free weights for serious strength training.",
  },
  {
    title: "Cardio Zone",
    description: "Treadmills, cycles and cardio equipment for complete fitness.",
  },
  {
    title: "Functional Zone",
    description: "Space for functional workouts, mobility and conditioning.",
  },
  {
    title: "Free Weight Zone",
    description: "Dumbbells, barbells and equipment for strength development.",
  },
];

// ===============================
// WHY JOIN FITRACK
// ===============================

export const WHY_JOIN = [
  {
    title: "Best Equipment",
    icon: "🏋️",
    text: "Modern and well-maintained gym equipment for different types of workouts.",
  },
  {
    title: "Expert Trainers",
    icon: "💪",
    text: "Trainers who can help members understand exercises and improve their workouts.",
  },
  {
    title: "Clean Environment",
    icon: "✨",
    text: "A clean and organized workout environment for comfortable training.",
  },
  {
    title: "Flexible Timings",
    icon: "⏰",
    text: "Convenient training hours so members can choose a suitable time.",
  },
  {
    title: "Affordable Plans",
    icon: "💳",
    text: "Different membership plans according to your preferred duration.",
  },
  {
    title: "Friendly Staff",
    icon: "🤝",
    text: "A welcoming environment for beginners as well as regular members.",
  },
];

// ===============================
// TRAINERS
// Change names, timings and images
// from this section only.
// ===============================

export const TRAINERS = [
  {
    name: "Arjun Sharma",
    role: "Strength Trainer",
    timing: "6:00 AM - 10:00 AM",
    image:
      "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?auto=format&fit=crop&w=700&q=80",
  },
  {
    name: "Simran Kaur",
    role: "Fitness Trainer",
    timing: "5:00 PM - 8:00 PM",
    image:
      "https://images.unsplash.com/photo-1594381898411-846e7d193883?auto=format&fit=crop&w=700&q=80",
  },
  {
    name: "Rahul Verma",
    role: "Functional Trainer",
    timing: "7:00 PM - 10:00 PM",
    image:
      "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=700&q=80",
  },
];

// ===============================
// HERO IMAGE
// ===============================

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=1600&q=85";

// ===============================
// ATHLETE IMAGES
// ===============================

export const ATHLETE_IMAGES = [
  "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?auto=format&fit=crop&w=900&q=80",
];

// ===============================
// QUOTES
// ===============================

export const QUOTES = [
  "Your body can achieve more than your mind thinks.",
  "Discipline creates results.",
  "Train hard. Stay consistent. Keep improving.",
];